import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    accountExtra3: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    clientName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    eventExtra1: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    eventExtra2: {
      validations: []
    },
    eventExtra3: {
      validations: []
    },
    eventExtra4: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Contact Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          },
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Person Filling Out Inquiry Form',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'FIRST NAME *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'LAST NAME *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'RELATIONSHIP *',
            options: [
              { label: 'Bride' , value: 'Bride'},
              { label: 'Groom' , value: 'Groom'},
              { label: 'Planner' , value: 'Planner'},
              { label: 'Parent' , value: 'Parent'},
              { label: 'Friend' , value: 'Friend'},
              { label: 'Other' , value: 'Other'},
            ],
            mapping: 'accountExtra3',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'EMAIL *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'PHONE *',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'BRIDE/GROOM NAME WEDDING *',
            mapping: 'clientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'NUMBER OF GUESTS *',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'PREFERRED DATE *',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'IS YOUR DATE FLEXIBLE? *',
            options: [
              { label: 'Yes' , value: 'Yes'},
              { label: 'No', value: 'No'},
            ],
            mapping: 'eventExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'WHAT ARE YOUR ALTERNATE DATE, IF ANY',
            mapping: 'eventExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'DO YOU NEED LODGING ACCOMMODATIONS?',
            options: [
              { label: 'Yes' , value: 'Yes'},
              { label: 'No', value: 'No'},
            ],
            mapping: 'eventExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'IF SO, HOW MANY ROOMS PER NIGHT?',
            mapping: 'eventExtra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'ANY OTHER ADDITIONAL DETAILS ABOUT YOUR EVENT',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Cliffs Hotel & Spa Weddings Form',
    formId: '557',
    clientKey: '7BC89166-AED5-48DA-9304-A56642D9D5B1',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/thecliffshotel2/form_structure.js